import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Construction Zones questions
export const constructionZonesMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-cz-1',
    text: {
      en: 'You are driving and see a construction zone ahead. What should you do?',
      nl: 'Je rijdt en ziet een wegwerkzone voor je. Wat moet je doen?',
      ar: 'أنت تقود وترى منطقة أعمال طرق أمامك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-1o1',
        text: {
          en: 'Reduce speed and be extra careful',
          nl: 'Verminder snelheid en wees extra voorzichtig',
          ar: 'قلل السرعة وكن حذرا بشكل إضافي'
        }
      },
      {
        id: 'q-cz-1o2',
        text: {
          en: 'Continue driving at normal speed',
          nl: 'Blijf rijden met normale snelheid',
          ar: 'استمر في القيادة بسرعة عادية'
        }
      },
      {
        id: 'q-cz-1o3',
        text: {
          en: 'Speed up to get through quickly',
          nl: 'Versnel om er snel doorheen te komen',
          ar: 'اسرع للعبور بسرعة'
        }
      }
    ],
    correctAnswerId: 'q-cz-1o1',
    explanation: {
      en: 'In construction zones, you must reduce your speed and be extra careful due to potential hazards and workers.',
      nl: 'In wegwerkzones moet je je snelheid verminderen en extra voorzichtig zijn vanwege potentiële gevaren en werknemers.',
      ar: 'في مناطق أعمال الطرق، يجب عليك تقليل سرعتك وكن حذرا بشكل إضافي بسبب المخاطر المحتملة والعمال.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-yield.jpg'
  },
  {
    id: 'q-cz-2',
    text: {
      en: 'You are driving in a construction zone and see workers on the road. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet werknemers op de weg. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى عمالا على الطريق. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-2o1',
        text: {
          en: 'Give extra space to workers and drive slowly',
          nl: 'Geef extra ruimte aan werknemers en rijd langzaam',
          ar: 'أعط مساحة إضافية للعمال واقود ببطء'
        }
      },
      {
        id: 'q-cz-2o2',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-cz-2o3',
        text: {
          en: 'Honk to warn the workers',
          nl: 'Toeter om de werknemers te waarschuwen',
          ar: 'استخدم البوق لتحذير العمال'
        }
      }
    ],
    correctAnswerId: 'q-cz-2o1',
    explanation: {
      en: 'When workers are present in construction zones, give them extra space and drive slowly to ensure their safety.',
      nl: 'Wanneer werknemers aanwezig zijn in wegwerkzones, geef hen extra ruimte en rijd langzaam om hun veiligheid te waarborgen.',
      ar: 'عندما يكون العمال موجودين في مناطق أعمال الطرق، أعطهم مساحة إضافية واقود ببطء لضمان سلامتهم.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-workers.jpg'
  },
  {
    id: 'q-cz-3',
    text: {
      en: 'You are driving in a construction zone and see a temporary speed limit sign. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een tijdelijk snelheidslimietbord. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى علامة حد سرعة مؤقتة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-3o1',
        text: {
          en: 'Follow the temporary speed limit',
          nl: 'Volg de tijdelijke snelheidslimiet',
          ar: 'اتبع حد السرعة المؤقت'
        }
      },
      {
        id: 'q-cz-3o2',
        text: {
          en: 'Continue driving at the normal speed limit',
          nl: 'Blijf rijden met de normale snelheidslimiet',
          ar: 'استمر في القيادة بحد السرعة العادي'
        }
      },
      {
        id: 'q-cz-3o3',
        text: {
          en: 'Ignore the temporary speed limit',
          nl: 'Negeer de tijdelijke snelheidslimiet',
          ar: 'تجاهل حد السرعة المؤقت'
        }
      }
    ],
    correctAnswerId: 'q-cz-3o1',
    explanation: {
      en: 'Temporary speed limit signs in construction zones must be followed. They are legally enforceable and designed for safety.',
      nl: 'Tijdelijke snelheidslimietborden in wegwerkzones moeten worden gevolgd. Ze zijn juridisch afdwingbaar en ontworpen voor veiligheid.',
      ar: 'يجب اتباع علامات حد السرعة المؤقتة في مناطق أعمال الطرق. إنها قابلة للتنفيذ قانونيا ومصممة للسلامة.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-70kmh.jpg'
  },
  {
    id: 'q-cz-4',
    text: {
      en: 'You are driving in a construction zone and see a lane closure. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een rijstrooksluiting. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى إغلاق ممر. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-4o1',
        text: {
          en: 'Merge into the open lane when safe',
          nl: 'Voeg in de open rijstrook wanneer het veilig is',
          ar: 'اندمج في الممر المفتوح عندما يكون آمنا'
        }
      },
      {
        id: 'q-cz-4o2',
        text: {
          en: 'Continue driving in the closed lane',
          nl: 'Blijf rijden in de gesloten rijstrook',
          ar: 'استمر في القيادة في الممر المغلق'
        }
      },
      {
        id: 'q-cz-4o3',
        text: {
          en: 'Stop and wait for the lane to reopen',
          nl: 'Stop en wacht tot de rijstrook weer opengaat',
          ar: 'توقف وانتظر حتى يفتح الممر مرة أخرى'
        }
      }
    ],
    correctAnswerId: 'q-cz-4o1',
    explanation: {
      en: 'When a lane is closed in a construction zone, merge into the open lane when it is safe to do so.',
      nl: 'Wanneer een rijstrook gesloten is in een wegwerkzone, voeg dan in de open rijstrook wanneer het veilig is om dat te doen.',
      ar: 'عندما يكون الممر مغلقا في منطقة أعمال الطرق، اندمج في الممر المفتوح عندما يكون ذلك آمنا.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-tegenverkeer.jpg'
  },
  {
    id: 'q-cz-5',
    text: {
      en: 'You are driving in a construction zone and see a flag person directing traffic. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een verkeersregelaar die het verkeer regelt. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى شخصا يوجه المرور. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-5o1',
        text: {
          en: 'Follow the flag person\'s directions',
          nl: 'Volg de aanwijzingen van de verkeersregelaar',
          ar: 'اتبع توجيهات الموجه'
        }
      },
      {
        id: 'q-cz-5o2',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-cz-5o3',
        text: {
          en: 'Honk to get the flag person\'s attention',
          nl: 'Toeter om de aandacht van de verkeersregelaar te trekken',
          ar: 'استخدم البوق لجذب انتباه الموجه'
        }
      }
    ],
    correctAnswerId: 'q-cz-5o1',
    explanation: {
      en: 'Flag persons in construction zones have authority to direct traffic. You must follow their directions for safety.',
      nl: 'Verkeersregelaars in wegwerkzones hebben de autoriteit om verkeer te regelen. Je moet hun aanwijzingen volgen voor veiligheid.',
      ar: 'الموجهون في مناطق أعمال الطرق لديهم سلطة توجيه المرور. يجب عليك اتباع توجيهاتهم للسلامة.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-flag-person.jpg'
  },
  {
    id: 'q-cz-6',
    text: {
      en: 'You are driving in a construction zone and see construction equipment on the road. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet bouwmaterieel op de weg. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى معدات بناء على الطريق. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-6o1',
        text: {
          en: 'Give extra space to the equipment and drive slowly',
          nl: 'Geef extra ruimte aan het materieel en rijd langzaam',
          ar: 'أعط مساحة إضافية للمعدات واقود ببطء'
        }
      },
      {
        id: 'q-cz-6o2',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-cz-6o3',
        text: {
          en: 'Speed up to get past the equipment quickly',
          nl: 'Versnel om snel langs het materieel te komen',
          ar: 'اسرع للعبور بسرعة بجانب المعدات'
        }
      }
    ],
    correctAnswerId: 'q-cz-6o1',
    explanation: {
      en: 'When construction equipment is on the road, give it extra space and drive slowly to avoid accidents.',
      nl: 'Wanneer bouwmaterieel op de weg staat, geef het extra ruimte en rijd langzaam om ongevallen te voorkomen.',
      ar: 'عندما تكون معدات البناء على الطريق، أعطها مساحة إضافية واقود ببطء لتجنب الحوادث.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-equipment.jpg'
  },
  {
    id: 'q-cz-7',
    text: {
      en: 'You are driving in a construction zone and see a detour sign. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een omleidingsbord. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى علامة تحويل. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-7o1',
        text: {
          en: 'Follow the detour route',
          nl: 'Volg de omleidingsroute',
          ar: 'اتبع مسار التحويل'
        }
      },
      {
        id: 'q-cz-7o2',
        text: {
          en: 'Continue driving on the original route',
          nl: 'Blijf rijden op de oorspronkelijke route',
          ar: 'استمر في القيادة على المسار الأصلي'
        }
      },
      {
        id: 'q-cz-7o3',
        text: {
          en: 'Ignore the detour sign',
          nl: 'Negeer het omleidingsbord',
          ar: 'تجاهل علامة التحويل'
        }
      }
    ],
    correctAnswerId: 'q-cz-7o1',
    explanation: {
      en: 'Detour signs in construction zones indicate alternative routes. You must follow the detour route for safety.',
      nl: 'Omleidingsborden in wegwerkzones geven alternatieve routes aan. Je moet de omleidingsroute volgen voor veiligheid.',
      ar: 'علامات التحويل في مناطق أعمال الطرق تشير إلى مسارات بديلة. يجب عليك اتباع مسار التحويل للسلامة.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-detour.jpg'
  },
  {
    id: 'q-cz-8',
    text: {
      en: 'You are driving in a construction zone and see a "Road Work Ahead" sign. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een "Wegwerkzaamheden Vooruit" bord. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى علامة "أعمال طرق أمامك". ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-8o1',
        text: {
          en: 'Prepare to slow down and be extra careful',
          nl: 'Bereid je voor om te vertragen en extra voorzichtig te zijn',
          ar: 'استعد للتباطؤ وكن حذرا بشكل إضافي'
        }
      },
      {
        id: 'q-cz-8o2',
        text: {
          en: 'Continue driving at normal speed',
          nl: 'Blijf rijden met normale snelheid',
          ar: 'استمر في القيادة بسرعة عادية'
        }
      },
      {
        id: 'q-cz-8o3',
        text: {
          en: 'Speed up to get through quickly',
          nl: 'Versnel om er snel doorheen te komen',
          ar: 'اسرع للعبور بسرعة'
        }
      }
    ],
    correctAnswerId: 'q-cz-8o1',
    explanation: {
      en: 'When you see a "Road Work Ahead" sign, prepare to slow down and be extra careful as you approach the construction zone.',
      nl: 'Wanneer je een "Wegwerkzaamheden Vooruit" bord ziet, bereid je voor om te vertragen en extra voorzichtig te zijn terwijl je de wegwerkzone nadert.',
      ar: 'عندما ترى علامة "أعمال طرق أمامك"، استعد للتباطؤ وكن حذرا بشكل إضافي أثناء اقترابك من منطقة أعمال الطرق.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-roadwork-ahead.jpg'
  },
  {
    id: 'q-cz-9',
    text: {
      en: 'You are driving in a construction zone and see orange cones marking a lane closure. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet oranje kegels die een rijstrooksluiting markeren. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى مخاريط برتقالية تحدد إغلاق ممر. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-9o1',
        text: {
          en: 'Follow the lane markings and merge when safe',
          nl: 'Volg de rijstrookmarkeringen en voeg in wanneer het veilig is',
          ar: 'اتبع علامات الممر وادمج عندما يكون آمنا'
        }
      },
      {
        id: 'q-cz-9o2',
        text: {
          en: 'Drive over the cones',
          nl: 'Rijd over de kegels',
          ar: 'اقود فوق المخاريط'
        }
      },
      {
        id: 'q-cz-9o3',
        text: {
          en: 'Ignore the cones and continue in your lane',
          nl: 'Negeer de kegels en blijf in je rijstrook',
          ar: 'تجاهل المخاريط واستمر في ممرك'
        }
      }
    ],
    correctAnswerId: 'q-cz-9o1',
    explanation: {
      en: 'Orange cones in construction zones mark lane closures. Follow the lane markings and merge into the open lane when it is safe to do so.',
      nl: 'Oranje kegels in wegwerkzones markeren rijstrooksluitingen. Volg de rijstrookmarkeringen en voeg in de open rijstrook wanneer het veilig is om dat te doen.',
      ar: 'المخاريط البرتقالية في مناطق أعمال الطرق تحدد إغلاق الممرات. اتبع علامات الممر وادمج في الممر المفتوح عندما يكون ذلك آمنا.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-cones.jpg'
  },
  {
    id: 'q-cz-10',
    text: {
      en: 'You are driving in a construction zone and see a "Reduce Speed" sign. What should you do?',
      nl: 'Je rijdt in een wegwerkzone en ziet een "Snelheid Verminderen" bord. Wat moet je doen?',
      ar: 'أنت تقود في منطقة أعمال طرق وترى علامة "قلل السرعة". ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-cz-10o1',
        text: {
          en: 'Reduce your speed to the indicated limit',
          nl: 'Verminder je snelheid tot de aangegeven limiet',
          ar: 'قلل سرعتك إلى الحد المحدد'
        }
      },
      {
        id: 'q-cz-10o2',
        text: {
          en: 'Continue at normal speed',
          nl: 'Blijf met normale snelheid rijden',
          ar: 'استمر بسرعة عادية'
        }
      },
      {
        id: 'q-cz-10o3',
        text: {
          en: 'Speed up to get through quickly',
          nl: 'Versnel om er snel doorheen te komen',
          ar: 'اسرع للعبور بسرعة'
        }
      }
    ],
    correctAnswerId: 'q-cz-10o1',
    explanation: {
      en: 'Speed limit signs in construction zones must be obeyed. Reduce your speed to the indicated limit for safety.',
      nl: 'Snelheidslimietborden in wegwerkzones moeten worden nageleefd. Verminder je snelheid tot de aangegeven limiet voor veiligheid.',
      ar: 'يجب الالتزام بعلامات حد السرعة في مناطق أعمال الطرق. قلل سرعتك إلى الحد المحدد للسلامة.'
    },
    subject: 'Construction Zones',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/construction-zones/construction-speed-limit.jpg'
  }
];

























